export default "__VITE_ASSET__P5kGlHh7__"